import React, { useEffect, useState } from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { purchaseRebateItemsFetchData } from '../../actions/purchaseRebateActions';
import NoRowExistsRow from '../../components/common/noRowExistsRow';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const flagTranslate = (flag) => {
  if (flag === 1) return 'DSD';
  if (flag === 2) return 'Investment';
  if (flag === 4) return 'CLP';
  if (flag === 3) return 'DSD, Investment';
  if (flag === 5) return 'DSD, CLP';
  if (flag === 6) return 'Investment, CLP';
  if (flag === 7) return 'DSD, Investment, CLP';
  return '';
};

const PurchaseRebateDetailsPage = () => {
  const dispatch = useDispatch();
  const purchaseRebate = useSelector(
    (state) => state.purchaseRebateItems ?? [],
  );
  const hasErrored = useSelector(
    (state) => state.purchaseRebateItemsHasErrored ?? false,
  );
  const isLoading = useSelector(
    (state) => state.purchaseRebateItemsIsLoading ?? true,
  );

  const [emptyRowString, setEmptyRowString] = useState('No Data Found');

  useEffect(() => {
    dispatch(purchaseRebateItemsFetchData());
  }, [dispatch]);

  const fundersRows =
    purchaseRebate && purchaseRebate.length > 0 ? (
      purchaseRebate.map((purchaseRebates) => (
        <div className='panel panel-default' key={purchaseRebates.id}>
          <Link to={`/purchase-rebate-details/${purchaseRebates.id}`}>
            <Row className='clickerMouse'>
              <Col md='3' className='white-border'>
                {purchaseRebates.offerFunderId}
              </Col>
              <Col md='3' className='white-border'>
                {purchaseRebates.rebateName}
              </Col>
              <Col md='2' className='white-border'>
                {moment
                  .utc(purchaseRebates.buyStartDate)
                  .local()
                  .format('DD-MMM-YYYY')}
              </Col>
              <Col md='2' className='white-border'>
                {moment
                  .utc(purchaseRebates.buyEndDate)
                  .local()
                  .format('DD-MMM-YYYY')}
              </Col>
              <Col md='2' className='white-border'>
                {flagTranslate(purchaseRebates.flags)}
              </Col>
            </Row>
          </Link>
        </div>
      ))
    ) : !isLoading ? (
      <NoRowExistsRow emptyRowText={emptyRowString} />
    ) : (
      <></>
    );

  return (
    <div>
      <h4>Manage Purchase Rebates</h4>
      <Link to='/purchase-rebate-form'>
        <Button className='btn btn-success mb-3 mt-3'>
          <FontAwesomeIcon icon={faPlus} /> Add New Rebate
        </Button>
      </Link>
      <Container fluid>
        <Row>
          <Col md='3' className='column-header white-border'>
            Funder Name
          </Col>
          <Col md='3' className='column-header white-border'>
            Rebate Name
          </Col>
          <Col md='2' className='column-header white-border'>
            Start Date
          </Col>
          <Col md='2' className='column-header white-border'>
            End Date
          </Col>
          <Col md='2' className='column-header white-border'>
            Flags
          </Col>
        </Row>
        {fundersRows}
        <Row>
          <Col>
            <BeatLoader color={'#004C5F'} loading={isLoading} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PurchaseRebateDetailsPage;
